import React from 'react';
import { LOGO_PLACEHOLDER } from '../utils/teamLogo';

const TeamCrest = ({ src, alt, size = 'md' }) => {
  const sizeClass = size === 'sm' ? 'team-crest--sm' : 'team-crest';
  return (
    <div className={sizeClass}>
      <img
        src={src || LOGO_PLACEHOLDER}
        alt={alt || ''}
        onError={(e) => { e.currentTarget.src = LOGO_PLACEHOLDER; }}
      />
    </div>
  );
};

export default TeamCrest;
